import { useState, useEffect } from "react";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";
import useCalculators from "../helpers/useCalculators";
import { displayCost } from "../helpers/strings";
import { BounceLoader } from "react-spinners";
import { coverageApi, unauthenticatedApi } from "../Api";
import Button from "./Button";

function PromoCodeInput({ onComplete }) {
    const {actions, state, sendState} = useStateMachineWrapper();
    const {getCartItems, getSubtotal, getApplicablePromo} = useCalculators();
    const [error, setError] = useState('');
    const [searchPromoValue, setSearchPromoValue] = useState(
      state.session.promoCode && state.session.promoCode.trim() !== '' ? state.session.promoCode : ''
  );
  
    const [loading, setLoading] = useState(false);

  const checkPromo = () => {    
    if (searchPromoValue.length >= 4 && searchPromoValue.length <= 12) {
        setLoading(true);
        const getData = setTimeout(() => {
            coverageApi.get(`promo-code?code=${searchPromoValue}&market_id=${state.session.marketID}&sector=${state.session.sector}&speed=${state.session.speed}`)
            //unauthenticatedApi.get(`?endpoint=promo-code&code=${searchPromoValue}&market_id=${state.session.marketID}&sector=${state.session.sector}`)
                .then(response => {
                    //console.log(response.data.results);
                    if(response.data.Response.Data.WebPromo !== null && response.data.Response.Data.WebPromo.Name !== ''){
                        //console.log('res',response.data.results);
                        actions.update({
                            promoCode: searchPromoValue,
                            promoCodeName: response.data.Response.Data.WebPromo.Name,
                            promoCodeAmount: -response.data.Response.Data.WebPromo.Amount,
                            promoCodePercent: response.data.Response.Data.WebPromo.Percent,
                            promoCodeError: '',
                            promoID: getApplicablePromo({speed: state.session.speed, pods: state.session.pods, groupId: state.session.promoGroupID}).id + ',' + response.data.Response.Data.WebPromo.ID,
                        });
                        setError('');
                        setSearchPromoValue('');
                       setLoading(false);
                       //updateAddress(address);
                    }
                    else{
                        //console.log('res',response.data.results);
                        actions.update({
                            promoCode: '',
                            promoCodeName: '',
                            promoCodeAmount: 0,
                            promoCodePercent: null,
                            promoCodeError: 'Promo Code not valid in your area',
                            promoID: getApplicablePromo({speed: state.session.speed, pods: state.session.pods, groupId: state.session.promoGroupID}).id,
                        });
                        setError('Promo Code not valid in your area');
                        //setSearchPromoValue('');
                        setLoading(false);
                        //showPopup();
                        return;
                    }
                    //actions.setPromoCodeData(response.data.results);
                })
                .catch(error => {
                  actions.update({
                    promoCode: '',
                    promoCodeName: '',
                    promoCodeAmount: 0,
                    promoCodePercent: null,
                    promoCodeError: 'Invalid Promo Code',
                    promoID: getApplicablePromo({speed: state.session.speed, pods: state.session.pods, groupId: state.session.promoGroupID}).id,
                });
                setError('Invalid Promo Code');
                    setLoading(false);
                    console.error('Error fetching promo code data:', error);
                });
        }, 500);

        //return () => clearTimeout(getData);
    }
    else{
        if (searchPromoValue.length !== 0) {
            actions.update({
                promoCode: '',
                promoCodeName: '',
                promoCodeAmount: 0,
                promoCodePercent: null,
                promoCodeError: 'Invalid Promo Code',
                promoID: getApplicablePromo({speed: state.session.speed, pods: state.session.pods, groupId: state.session.promoGroupID}).id,
            });
            setError('Invalid Promo Code');
            //setSearchPromoValue('');
            setLoading(false);
            //showPopup();
            return;
        }
        else{
            return;
            actions.update({
                promoCode: '',
                promoCodeName: '',
                promoCodeAmount: 0,
                promoCodePercent: null,
                promoCodeError: '',
            });
            //setError('');
            //setSearchPromoValue('');
            setLoading(false);
            //updateAddress(address);
        }
    }

  };
  
  useEffect(() => {
    checkPromo();
  }, [state.session.speed]);

  const handleEnter = (e) => {
    if(e.key === 'Enter'){
      checkPromo();
    }
  };

  const containerStyle = {
    display: 'flex', // Flexbox layout
    flexDirection: 'column', // Arrange children in a column
    alignItems: 'flex-end', // Center horizontally
    borderTop: '1px solid rgb(226, 232, 240)',
    paddingTop: '20px',
    //width: 'fit-content',
    //margin: '0px auto', // Center horizontally in parent
  };
  
  const labelStyle = {
    fontSize: '16px',
    color: '#333', // Darker text color for readability
    marginBottom: '8px', // Space below label
  };
  
  const inputContainerStyle = {
    display: 'flex', // Arrange input and button in a row
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '8px', // Space below input and button
  };
  
  const inputStyle = {
    border: 'none',
    borderBottom: '2px solid #ddd', // Light bottom border
    padding: '0px 0',
    fontSize: '16px',
    width: '150px', // Increased width for input field
    marginRight: '10px', // Space between input and button
    transition: 'border-color 0.3s', // Smooth transition
    outline: 'none',
    boxShadow: 'none',
  };
  
  const inputFocusStyle = {
    borderBottom: '2px solid #3498db', // Change border on focus
  };
  
  return (
    <div className='px-6' style={containerStyle}>
      <>
        {/* Label Row */}
        <span style={labelStyle}>If you have a special promo code, please enter it here</span>
  
        {/* Input and Button Row */}
        <div style={inputContainerStyle}>
          <input
            type="text"
            value={searchPromoValue}
            onChange={(e) => setSearchPromoValue(e.target.value)}
            onKeyDown={handleEnter}
            style={{
              ...inputStyle,
              ...(searchPromoValue.length > 12 ? inputFocusStyle : {}),
            }}
            placeholder="Promo Code"
          />
          <Button size='small' color='yellow' onClick={checkPromo} disabled={loading}>
            {loading ? (
              <BounceLoader color={'#3498db'} loading={loading} size={24} /> 
            ) : (
              <>Apply</>
            )}
          </Button>
        </div>
  
        {/* Error Message */}
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </>
    </div>
  );
  

 
}

export default PromoCodeInput;